import React, { useRef, useState } from "react";
import Modal from "react-bootstrap/Modal";
import { Dimmer } from "../components/spinner";
import { TableBody, TableRow, TableCell } from "@material-ui/core";
import { Mensaje } from "../components/mensajes";
import axios from "axios";
import useTableScroll from "../components/useTableScroll.js";
import { formatMoneda } from "../util/varios";

const CatalogoVerificarPersona = (props) => {
  const op = require("../../public/modulos/datos");
  const token = JSON.parse(localStorage.getItem("jwtToken"));
  const btnCancela = useRef();
  const [activate, setActivate] = useState(false);
  const [records, setRecords] = useState([]);
  const [values, setValues] = useState({});
  const [activo, setActivo] = useState(true);
  const [itemSelect, setItemSelect] = useState(-1);
  const [filterFn, setFilterFn] = useState({
    fn: (items) => {
      return items;
    },
  });
  const [mensaje, setMensaje] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });

  const headCells = [
    { label: "PREFACTURA", textAlign: "center" },
    { label: "VERIFICADOR", textAlign: "center" },
    { label: "MONTO", textAlign: "center" },
  ];

  const { TblContainer, TblHead, TblPagination, recordsAfterPagingAndSorting } =
    useTableScroll(records, headCells, filterFn);

  const handleSearch = (e) => {
    let target = e.target;

    setFilterFn({
      fn: (items) => {
        if (target.value === "") {
          return items;
        } else {
          return items.filter((x) => {
            if (
              (x.prefactura !== null
                ? x.prefactura
                    .toLowerCase()
                    .includes(target.value.toLowerCase())
                : "") ||
              (x.liquidador !== null
                ? x.liquidador
                    .toLowerCase()
                    .trim()
                    .includes(target.value.toLowerCase())
                : "") ||
              (x.montototal !== null
                ? x.montototal
                    .toLowerCase()
                    .includes(target.value.toLowerCase())
                : "")
            ) {
              return x;
            }
          });
        }
      },
    });
  };

  const seleccionarVerificaciones = () => {
    setActivate(true);
    let endpoint = op.conexion + "/api/Caja_Ingreso/selectverificaciones";

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then((response) => {
        if (response.status === 200) {
          setActivate(false);
          if (response.data.length > 0) {
            setRecords(response.data);
          } else {
            setRecords([]);
          }
        }
        setActivate(false);
      })
      .catch(function (error) {
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
      })
      .finally(() => {
        setActivate(false);
      });
  };

  const blanquear = () => {
    setActivate(false);
    setRecords([]);
    setItemSelect("");
    setFilterFn({
      fn: (items) => {
        return items;
      },
    });
    setActivo(true);
  };

  const cancelar = () => {
    blanquear();
    props.onHideCancelaCatActi();
  };

  const seleccionarAgentes = () => {
    blanquear();
    props.onHideAceptaCat(
      values.idverificacion,
      values.idverificador,
      values.montototal,
      values.liquidador,
      values.prefactura,
      values.idtipoingreso,
      values.fechaverificacion,
      values.cedula,
      values.status
    );
    props.onHideCancelaCatActi();
  };

  const seleccionarFila = (index) => (e) => {
    e.preventDefault();
    setActivo(false);
    setItemSelect(index);
    setValues({
      idverificacion: recordsAfterPagingAndSorting()[index].idverificacion,
      idverificador: recordsAfterPagingAndSorting()[index].idverificador,
      montototal: recordsAfterPagingAndSorting()[index].montototal,
      liquidador: recordsAfterPagingAndSorting()[index].liquidador,
      prefactura: recordsAfterPagingAndSorting()[index].prefactura,
      idtipoingreso: recordsAfterPagingAndSorting()[index].idtipoingreso,
      fechaverificacion:
        recordsAfterPagingAndSorting()[index].fechaverificacion,
      cedula: recordsAfterPagingAndSorting()[index].cedula,
      status: recordsAfterPagingAndSorting()[index].status,
    });
  };

  return (
    <Modal
      {...props}
      aria-labelledby="contained-modal-title-vcenter"
      centered
      style={{ backgroundColor: "rgb(0,0,0,0.5)" }}
      size="lg"
      backdrop="static"
      keyboard={false}
      onShow={() => {
        seleccionarVerificaciones();
      }}
    >
      <Modal.Header className="azulGradiant2 header-modal">
        <div className="fw-bold text-light">
          <h3 className="text-capitalize">
            {"Contribuyentes de - "}
            {props.tipo === "idtipoagente" ? "timbres" : props.tipo}
          </h3>
        </div>
        <button
          ref={btnCancela}
          className="bg-transparent"
          style={{ border: 0, margin: 0, padding: 0, color: "#ffffff" }}
          onClick={cancelar}
        >
          <i className="far fa-window-close"></i>
        </button>
      </Modal.Header>
      <Modal.Body>
        <div className="row col-md-12" style={{ marginBottom: "2px" }}>
          <div className="input-group col-md-4 input-group-sm mb-3">
            <input
              type="text"
              onChange={handleSearch}
              className="form-control"
            />
            <button className="btn btn-info" style={{ pointerEvents: "none" }}>
              <i className="fa fa-search"></i>
            </button>
          </div>
        </div>
        <div className="col-md-12" style={{ margin: "auto" }}>
          <TblContainer>
            <TblHead />

            <TableBody>
              {records &&
                recordsAfterPagingAndSorting().map((item, index) => (
                  <TableRow
                    key={index}
                    style={{
                      padding: "0",
                      cursor: "pointer",
                      background:
                        itemSelect === index ? "lightskyblue" : "white",
                    }}
                    onClick={seleccionarFila(index)}
                  >
                    <TableCell className="py-2 text-center">
                      {item.prefactura}
                    </TableCell>
                    <TableCell className="py-2 text-start">
                      {item.liquidador}
                    </TableCell>
                    <TableCell className="py-2 text-end">
                      {item.montototal !== null
                        ? formatMoneda(
                            item.montototal.toString().replace(".", ","),
                            ",",
                            ".",
                            2
                          )
                        : "0,00"}
                    </TableCell>
                  </TableRow>
                ))}
            </TableBody>
          </TblContainer>
          <TblPagination />
        </div>
      </Modal.Body>
      <Modal.Footer>
        <button
          className="btn btn-sm btn-success rounded-pill"
          disabled={activo}
          style={{ margin: "5px" }}
          onClick={seleccionarAgentes}
        >
          <i className="fas fa-check-circle"> Aceptar</i>{" "}
        </button>
        <button
          ref={btnCancela}
          onClick={cancelar}
          className="btn btn-sm btn-danger rounded-pill"
        >
          <i className="fas fa-window-close"> Cancelar</i>
        </button>
      </Modal.Footer>
      <Dimmer active={activate} />
      <Mensaje
        mensaje={mensaje}
        onHide={() => {
          setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" });
        }}
      />
    </Modal>
  );
};

export default CatalogoVerificarPersona;



// WEBPACK FOOTER //
// ./src/catalogos/catalogoVerifipersona.js